
import { useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom"
//--------------------------------------------------------------------------------------------
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import { gatherHours, calculateHours } from "src/components/payroll/payroll";
import { useMyStore } from "src/components/main/mainStore";
import { 
    round, 
    numberReducer, 
    weeknum, 
    onlyUnique, 
    myAxios, 
    objAscSort, 
    MyFormData, 
    getDatefromWeekNum, 
    getTimeStamp,
    appTitle,
    boolAndReducer
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Hours({ tabTitle }){
    //--------------------------------------------------------------------------------------------
    // if(isDevMode) console.log("all");
    //--------------------------------------------------------------------------------------------
    const user = useMyStore(state => state.user);
    const allWorkLogs = useMyStore((state) => state.hoursWorkLogs);
    const setWorkLogs = useMyStore((state) => state.setHoursWorkLogs);
    const weeks = useMyStore((state) => state.hoursWeeks);
    const setWeeks = useMyStore((state) => state.setHoursWeeks);
    const week = useMyStore((state) => state.hoursWeek);
    const setWeek = useMyStore((state) => state.setHoursWeek);
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = decodeURIComponent(path.split("/")[1] ?? "");
    const path2 = decodeURIComponent(path.split("/")[2] ?? "");
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Weeks": weeks.updatedAt === null?getTimeStamp():weeks.updatedAt, 
        "Work Logs": allWorkLogs.updatedAt === null?getTimeStamp():allWorkLogs.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    const [filterWords, setFilterWords] = useState("");
    //--------------------------------------------------------------------------------------------
    const allData = useMemo(() => {
        if(week === null || allWorkLogs[week] === undefined) return [];
        const curRawData = (allWorkLogs[week] ?? []).map(raw => ({...raw, 
            travelStartTime: raw.travelStartTime.replace(/-/g, "/"),
            workStartTime: raw.workStartTime.replace(/-/g, "/"),
            workEndTime: raw.workEndTime.replace(/-/g, "/"),
            travelEndTime: raw.travelEndTime.replace(/-/g, "/")
        })).filter(raw => 
            weeknum(raw.travelStartTime) === week
        );
        //-----------------------------------------------------------
        const filteredUniqueDates = curRawData.map(raw => 
            raw.travelStartTime.substring(0, 10)
        )
        .filter(onlyUnique)
        .map(f => 
            curRawData
            .filter(ff => ff.travelStartTime.substring(0, 10) === f)
        );
        //calculate 
        filteredUniqueDates.forEach((f, i) => {
            //generalize
            const dataArray = [];
            f.sort((a, b) => objAscSort(a, b, "startTime")).forEach(ff => {
                dataArray.push(gatherHours(ff, user.unionName));
            });
            //valid
            const totalHours = dataArray.map(d => d.reduce(numberReducer, 0)).reduce(numberReducer, 0);
            const final = calculateHours(
                totalHours - dataArray.map(d => d[1]).reduce(numberReducer, 0) - dataArray.map(d => d[2]).reduce(numberReducer, 0), 
                dataArray.map(d => d[1]).reduce(numberReducer, 0), 
                dataArray.map(d => d[2]).reduce(numberReducer, 0), 
                Date.parse(f[0].travelStartTime.replace(/-/g, "/")), 
                Date.parse(f[0].travelEndTime.replace(/-/g, "/")), 
                user.unionName, 
                user.email,
                filteredUniqueDates[i][0].laborCategory === "Travel",
                user.department
            );
            filteredUniqueDates[i][0].regular = final[0];
            filteredUniqueDates[i][0].ot1 = final[1];
            filteredUniqueDates[i][0].ot2 = final[2];
            filteredUniqueDates[i][0].travel = final[3];
        });
        return filteredUniqueDates;
    }, [allWorkLogs, week, user.department, user.email, user.unionName]);
    const filteredData = useMemo(() => allData.filter(dayWorkLogs => filterWords.toLowerCase().split(" ").map(f => JSON.stringify(dayWorkLogs).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true)), [allData, filterWords]);
    //---------------------------------------------------------------------
    useEffect(() => {
        if(week === null) setWeek(path2);
      }, [week, setWeek, path2]);
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(week === null || updateDateTime["Weeks"] === weeks.updatedAt) return;
        const controller = new AbortController();
        let isMounted = true;
        const getData = async () => {
            //--------------------------
            setShowLoading(true);
            const resWeeks = await myAxios("workLogs/readWeek.php", undefined, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!resWeeks) return;
            //--------------------------
            const dateArray = [];
            const min = new Date(resWeeks.data.minTime.replace(/-/g, "/"));
            const max = new Date(resWeeks.data.maxTime.replace(/-/g, "/"));
            while(min < max){
                dateArray.push(weeknum(max));
                max.setDate(max.getDate() - 7);
            }
            if(!dateArray.includes(weeknum(min))){
                dateArray.push(weeknum(min));
            }
            setWeeks(dateArray, updateDateTime["Weeks"]);
            if(!dateArray.includes(week)){
                const thisWeek = weeknum(new Date());
                setWeek(thisWeek);
                history.replace(`/${path1}/${thisWeek}`);
            }
        }
        getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [history, path1, setWeeks, updateDateTime, week, setWeek, weeks.updatedAt])
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(weeks.updatedAt !== updateDateTime["Weeks"]) return;
        let isMounted = true;
        const controller = new AbortController();
        const getData = async () => {
            //--------------------------
            const formData = new MyFormData();
            formData.append("weekStart", getDatefromWeekNum(week, 0));
            formData.append("weekEnd", getDatefromWeekNum(week, 6));
            //--------------------------
            setShowLoading(true);
            const res = await myAxios("hours/readLaborWorkLogs.php", formData, undefined, controller.signal);
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //--------------------------
            setWorkLogs(week, res.data, updateDateTime["Work Logs"]);
        }
        if(!allWorkLogs[week] || updateDateTime["Work Logs"] !== allWorkLogs.updatedAt) getData();
        return () => {
            isMounted = false;
            controller.abort();
        }
    }, [allWorkLogs, setWorkLogs, updateDateTime, week, weeks.updatedAt])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return (
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    {tabTitle}
                    <span
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary py-1 ml-4"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </span>
                </span>
                <span>
                    <input
                        id = "searchBar"
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "week" className = "mb-0">Week:</label>
                    <select
                        id = "week"
                        className = "form-control ml-3"
                        value = {path2}
                        onChange = {e => {
                            setWeek(e.currentTarget.value);
                            history.push(`/${path1}/${e.currentTarget.value}`);
                        }}
                    >
                        {weeks.data.map((wk, key) => <option key = {key}>{wk}</option>)}
                    </select>
                </span>
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filteredData.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th>Date</th> 
                                <th>Project Name</th>                    
                                <th>Calculated Regular Hours</th>
                                <th>Calculated OT-1.5 Hours</th>
                                <th>Calculated OT-2 Hours</th>
                                <th>Calculated Travel Hours</th>
                            </tr>
                        </thead>
                        <tbody> 
                            {filteredData.map((dayWorkLogs, dayWorkLogsIdnex) =>
                            <tr key = {dayWorkLogsIdnex}>
                                <td>
                                    <div className = "text-center">{dayWorkLogs[0].travelStartTime.substring(0, 10)}</div>
                                    {dayWorkLogs[0].travelStartTime.substring(0, 10) !== dayWorkLogs[0].travelEndTime.substring(0, 10)?
                                    <div className = "text-center"><span className = "badge badge-info">overnight</span></div>:null}
                                </td>
                                <td>
                                    {dayWorkLogs.map((workLog, workLogIndex) => 
                                    <li key = {workLogIndex}>
                                        <Link to = {`/WorkLogs/${workLog.workLogHashKey}`}>
                                            {workLog.projectName}
                                        </Link>
                                    </li>)}
                                </td>
                                <td>{round(dayWorkLogs[0].regular, 2)}</td>
                                <td>{round(dayWorkLogs[0].ot1, 2)}</td>
                                <td>{round(dayWorkLogs[0].ot2, 2)}</td>
                                <td>{round(dayWorkLogs[0].travel, 2)}</td>
                            </tr>
                            )}
                            <tr>
                                <td><strong>Total</strong></td>
                                <td></td>
                                <th>
                                    {round(filteredData.map(dayWorkLogs => dayWorkLogs[0].regular).reduce(numberReducer, 0), 2)}
                                </th>
                                <th>
                                    {round(filteredData.map(dayWorkLogs => dayWorkLogs[0].ot1).reduce(numberReducer, 0), 2)}
                                </th>
                                <th>
                                    {round(filteredData.map(dayWorkLogs => dayWorkLogs[0].ot2).reduce(numberReducer, 0), 2)}
                                </th>
                                <th>
                                    {round(filteredData.map(dayWorkLogs => dayWorkLogs[0].travel).reduce(numberReducer, 0), 2)}
                                </th>
                            </tr>
                        </tbody>
                    </table>
                    <div className = "text-danger m-2">* Note: this may not be the final result.</div>
                </div>}
            </div>
        </div>
    )
}